import * as React from 'react';
import * as styles from './DueDatePicker.scss';
import { observer } from 'mobx-react-lite';
import type { IButtonStyles } from '@fluentui/react/lib/Button';
import type { OwaDate } from 'owa-datetime';
import { SimpleDropDownDatePicker } from 'owa-datepicker-simpledropdowndatepicker';
import classNames from 'classnames';
import getDueDateStyle from '../utils/getDueDateStyle';
import getDueDateText from '../utils/getDueDateText';
import DueDateCompletionCheckbox from './DueDateCompletionCheckbox';
import DueDateRemoveButton from './DueDateRemoveButton';

const chooseDateStyles: IButtonStyles = {
    flexContainer: {
        maxWidth: '100%',
    },
};

export default observer(function DueDatePicker({
    className,
    iconClassName,
    buttonClassName,
    chooseDateText,
    date,
    onDateSelected,
    onDateRemoved,
    isCompleted,
    onIsCompletedChanged,
    hideIcon,
    hideDateOnCompletion,
}: {
    className?: string;
    iconClassName?: string;
    buttonClassName?: string;
    chooseDateText: string;
    date: OwaDate | null | undefined;
    onDateSelected: (date: OwaDate | null) => void;
    onDateRemoved: () => void;
    isCompleted: boolean;
    onIsCompletedChanged: (newValue: boolean) => void;
    hideIcon?: boolean;
    hideDateOnCompletion?: boolean;
}) {
    const dueDateStyle = getDueDateStyle(date, isCompleted);
    const rootClassName = classNames(className || '', dueDateStyle);
    const buttonsClassNames = classNames(buttonClassName || styles.datePickerButtons);

    const iconClassNames = classNames(iconClassName || styles.datePickerIcon, {
        [styles.datePickerIconHidden]: !!hideIcon,
    });

    const formatDate = React.useCallback(
        (d: OwaDate) => getDueDateText(d, isCompleted, hideDateOnCompletion),
        [isCompleted]
    );

    return (
        <SimpleDropDownDatePicker
            className={rootClassName}
            iconClassName={iconClassNames}
            buttonsClassName={buttonsClassNames}
            chooseDateText={chooseDateText}
            chooseDateStyles={chooseDateStyles}
            formatDate={formatDate}
            showChevron={true}
            value={date}
            onDateSelected={onDateSelected}>
            <>
                <DueDateCompletionCheckbox
                    isCompleted={isCompleted}
                    disabled={!date}
                    onIsCompletedChanged={onIsCompletedChanged}
                />
                {!!date && <DueDateRemoveButton onRemoveDueDate={onDateRemoved} />}
            </>
        </SimpleDropDownDatePicker>
    );
});
